<template>
  <div>
    <div class="event-setup-left-top">
      <h3>{{ eventFullName }}</h3>
      <p>
        {{ eventTime }}
      </p>
    </div>
    <div class="left-setup-menu">
      <ul>
        <li
          v-for="(item, index) in ssMenu"
          :key="index"
          v-bind:class="{
            'work-step': $route.name == item.routeName,
            'done-step': item.StepStatus == 'visited',
          }"
        >
          
          <router-link v-if="item.routeTo.includes('{{EventId}}')" :to="item.routeTo.replace('{{EventId}}',eventId)"><span>{{ index + 1 }}</span> {{ item.DisplayName }}</router-link>
          <router-link v-else :to="item.routeTo"><span>{{ index + 1 }}</span> {{ item.DisplayName }}</router-link>
        </li>
        <!-- <li>
          <span>7</span><a href="javascript:void(0);">Preview &amp; Publish</a>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import ss_config from "@/assets/ss-config";
var vm;
export default {
  props: {
    eventFullName: {
      type: String,
      default: "",
    },
    eventTime: {
      type: String,
      default: "",
    },
    MenuIDs: {
      type: Array,
      default: () => [],
    },
    eventId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ssMenu: [],
    };
  },
  watch: {
    MenuIDs() {
      vm.getSSMenu();
      vm.getSSMenuStatus();
    },
  },
  async created() {
    vm = this;
    vm.getSSMenu();
    vm.getSSMenuStatus();
  },
  methods: {
    getSSMenu() {
      vm.ssMenu = [];
      var ssConfigMenu = [...ss_config.SS_Menu];
      for (let i = 0; i < ssConfigMenu.length; i++) {
        if (ssConfigMenu[i].IsPublished) {
          if (
            ssConfigMenu[i].PreviewMenuId == 0 ||
            vm.MenuIDs.includes(ssConfigMenu[i].PreviewMenuId)
          ) {
            vm.ssMenu.push({
              PreviewMenuId: ssConfigMenu[i].PreviewMenuId,
              DisplayName: ssConfigMenu[i].DisplayName,
              DisplayOrder: ssConfigMenu[i].DisplayOrder,
              StepStatus: ssConfigMenu[i].StepStatus,
              routeTo: ssConfigMenu[i].routeTo,
              routeName: ssConfigMenu[i].routeName,
              IsPublished: true,
            });
          }
        }
      }
      vm.ssMenu.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
    },
    async getSSMenuStatus() {
      await db
        .collection(this.getEventCollectionName())
        .doc("EventInfo")
        .onSnapshot(async (doc) => {
          if (doc.data().SS_Features) {
            for (let key of Object.keys(doc.data().SS_Features)) {
              let item = doc.data().SS_Features[key];
              for (var i = 0; i < vm.ssMenu.length; i++) {
                if (vm.ssMenu[i].routeName == item.routeName) {
                  vm.ssMenu[i].StepStatus = item.StepStatus
                    ? item.StepStatus
                    : "notvisited";
                }
              }
            }
          }
        });
    },
  },
};
</script>
